import { Injectable } from '@angular/core';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { CLIENTE_ANALISES_MERCADOS_FULL_PATH_ROUTE } from '../cliente-analise-mercado.routes';
import { Location } from '@angular/common';
import { ClienteAnaliseMercadoQueryParams, ClienteAnaliseMercadoOrigin } from '../cliente-analise-mercado.params';

@Injectable({
    providedIn: 'root'
})
export class ClienteAnaliseMercadoRouterService {

    constructor(private router: Router,
                private location: Location) { }


    /** Obtem as querys params do router */
    getQueryParams(activatedRoute: ActivatedRoute): ClienteAnaliseMercadoQueryParams {
        if (!activatedRoute) {
            return null;
        }

        const queryParams: ClienteAnaliseMercadoQueryParams = {}
        activatedRoute.queryParams.subscribe((params: Params) => {
            // Origin
            queryParams.origin = params['origin'];
        });

        return queryParams;
    }

    /** Abre a rota das Análises de mercado */
    open(origin: ClienteAnaliseMercadoOrigin, queryParams: Params, activatedRoute: ActivatedRoute) {
        if (!queryParams) {
            queryParams = {};
        }

        if (origin) {
            queryParams['origin'] = origin;
        }

        this.router.navigate([`/${CLIENTE_ANALISES_MERCADOS_FULL_PATH_ROUTE}`], {
            relativeTo: activatedRoute,
            queryParams
        });
    }

    /** Retorna para a rota anterior */
    back(): void {
        this.location.back();
    }
}
